module.exports = __webpack_public_path__ + "img/newsSwiper.6de3daad.png";